var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("multi-select " + (_vm.isMobile || _vm.keyboardEnabled ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: 'calc(100% - 45px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [!_vm.keyboardEnabled && _vm.currentRound.questionHtml ? _c('activity-question', {
    attrs: {
      "textHtml": _vm.currentRound.questionHtml,
      "answers": _vm.currentRound.answers,
      "tableData": _vm.currentRound.table,
      "image": _vm.currentRound.image,
      "numOfAttempts": _vm.numberOfAttempts[0] || 0,
      "shouldShowHints": _vm.activityStatus.showHints
    }
  }) : _vm._e(), !_vm.keyboardEnabled ? _c('article', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('article', {
    staticStyle: {
      "margin": "8px 0px"
    },
    attrs: {
      "aria-live": "polite",
      "role": "region"
    }
  }, [_c('i', [_vm._v("* No more than two answers can be selected.")])]), !_vm.keyboardEnabled ? _c('multi-select-check-boxes', {
    attrs: {
      "answers": _vm.currentRound.answers,
      "lockedAnswers": _vm.lockedCheckBoxSelections,
      "resetCheckBoxAfterErrors": true,
      "showErrors": _vm.activityStatus.showErrors,
      "showHints": _vm.activityStatus.showHints,
      "showSuccess": true
    },
    on: {
      "onCheckBoxesSelectionChange": _vm.handleOnCheckBoxesSelectionChange
    }
  }) : _vm._e(), _c('div', {
    staticStyle: {
      "position": "absolute",
      "visibility": "hidden"
    },
    attrs: {
      "aria-atomic": "true",
      "id": "multiSelectErrorMessage",
      "role": "alert"
    }
  }), _c('div', {
    staticStyle: {
      "position": "absolute",
      "visibility": "hidden"
    },
    attrs: {
      "id": "multiSelectCorrectAnswer"
    }
  }, [_vm._v("\n          This is one of the correct answers\n        ")])], 1) : _vm._e(), _vm.keyboardEnabled ? _c('div', {
    attrs: {
      "id": "textContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "steps"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.typeOverText.directionsHtml
    }
  }), _c('text-display-list', {
    attrs: {
      "id": "input",
      "text-size": "medium-large"
    }
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.currentRound.typeOverText.text,
      "text-step": 0
    }
  })], 1)], 1)]) : _vm._e()], 1)], 2), _c('article', {
    style: {
      display: _vm.keyboardEnabled ? 'block' : 'none'
    }
  }, [_vm._t("keyboard")], 2), _vm.showActivityNextSectionPortal ? _c('activity-next-section-portal', {
    attrs: {
      "handleOnActivitySubmit": _vm.handleOnActivitySubmit
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }